<template>
    <div class="buttons is-right mr-5">
        <b-button
            outlined
            icon-left="angle-left"
            :disabled="previous.disabled"
            @click.prevent="previous.action">
            Back
        </b-button>
        <b-button v-if="!next.disabled"
            outlined
            icon-right="angle-right"
            :disabled="next.disabled"
            @click.prevent="next.action">
            Continue
        </b-button>
        <template v-if="!locked">
            <b-button v-if="step==5"
                outlined type="is-success"
                icon-left="grin-stars"
                @click.prevent="finaliseBattle('win')">
                Victorious
            </b-button>
            <b-button v-if="step==5"
                outlined type="is-danger"
                icon-left="grimace"
                @click.prevent="finaliseBattle('lose')">
                Failure
            </b-button>
        </template>
    </div>
</template>

<script>
export default {
    props: ['step','previous','next','finaliseBattle','locked']
}
</script>